import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  ElementRef,
} from '@angular/core';
import { Directional } from 'src/app/interfaces/directional';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CasingLiner, GroupCasingLiner } from '../../interfaces/casing-liner';
import { DialogService } from 'src/app/services/dialog.service';
import { HANDOVER_STATUS_ACCEPTED } from 'src/app/handover-constants';
import { PendingChanges } from 'src/app/components/shared/pending-changes.class';
import { Handover } from 'src/app/interfaces/handover';

@Component({
  selector: 'app-handover-detail-well-architecture',
  templateUrl: './handover-detail-well-architecture.component.html',
  styleUrls: ['./handover-detail-well-architecture.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverDetailWellArchitectureComponent
  extends PendingChanges
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() readOnlyContent!: boolean;

  casingsLiners: CasingLiner[] = [];
  comments: string[] = [];
  isLoading = false;
  showFooterNoDataOrign = false;

  displayedColumns: string[] = [
    'wellboreNo',
    'assemblyName',
    'holeSize',
    'groupValues',
    'mdLanded',
    'mdLinerTop',
    'mdMarkerTop',
    'actions',
  ];

  directionals: Directional[] = [];

  displayedColumnsDirectionals: string[] = [
    'wellboreNo',
    'toolMaxDls',
    'mdMaxDoglegSev',
    'maxDoglegSev',
    'maxInclination',
    'toolMaxInc',
  ];
  hideFooter = true;
  hideFooterCasing = true;
  panelOpenState = false;
  isDisabled: boolean[] = [];
  originalCasingLiners: CasingLiner[] = [];
  indexMenuOpen = -1;
  changesCounter = 0;

  constructor(
    public handoverService: HandoverService,
    private notificationService: NotificationService,
    public dialogService: DialogService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handover!.handoverId) {
      this.isLoading = true;
      this.loadCasingsLinersAndDirectionals();
      this.showFooterNoDataOrign =
        this.handover!.handoverStatusId != HANDOVER_STATUS_ACCEPTED;
    }
  }

  loadCasingsLinersAndDirectionals(): void {
    this.handoverService
      .getCasingLiner(
        this.handover!.handoverId,
        this.handover!.wellId,
        this.handover!.handoverStatusId,
        this.handover!.handoverTypeId
      )
      .subscribe((casingsLiners: CasingLiner[]) => {
        casingsLiners.forEach((element) => {
          this.comments.push(element.comment);
        });
        this.casingsLiners = casingsLiners;
        this.hideFooterCasing = casingsLiners.length > 0;
        this.setOriginalCasingLinersValues(casingsLiners);
        this.handoverService
          .getDirectional(
            this.handover!.handoverId,
            this.handover!.wellId,
            this.handover!.handoverStatusId,
            this.handover!.handoverTypeId
          )
          .subscribe((directionals: Directional[]) => {
            this.directionals = directionals;
            this.isLoading = false;
            this.hideFooter = directionals.length > 0;
          });
      });
  }

  setOriginalCasingLinersValues(casingsLiners: CasingLiner[]): void {
    casingsLiners.map((val) => {
      if (val.comment == null) val.comment = '';
      this.originalCasingLiners.push(Object.assign({}, val));
      this.isDisabled.push(true);
    });
  }

  saveCasingLiner(casingLiner: CasingLiner, index: number): void {
    this.dialogService
      .openConfirmDialog(
        'Casing / Liner',
        '¿Desea guardar los cambios de Casing/Liner?'
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          casingLiner.handoverId = this.handover!.handoverId!;
          const casingsLiners: CasingLiner[] = [];
          casingsLiners.push(casingLiner);

          this.handoverService
            .saveCasingLinerComment(casingsLiners)
            .subscribe((savedCasingLiner: CasingLiner[]) => {
              if (savedCasingLiner) {
                this.notificationService.notify(
                  'Casing/Liner guardado satisfactoriamente',
                  true
                );
                this.isDisabled[index] = true;
                this.originalCasingLiners[index].comment = casingLiner.comment;
                this.reportPendingChanges();
              } else {
                this.notificationService.notify(
                  'Ocurrió un error al guardar el Casing/Liner',
                  false
                );
              }
            });
        }
      });
  }

  openComments(
    comments: string | undefined,
    index: number,
    event: any,
    readOnly: boolean
  ): void {
    const target = new ElementRef(event.currentTarget);
    this.dialogService
      .openCommentDialog(
        'Si hay marcadores (caño corto/pin radioactivo) indicar la profundidad.',
        comments,
        target,
        -200,
        -450,
        readOnly
      )
      .afterClosed()
      .subscribe((comments: string) => {
        this.casingsLiners[index].comment = comments;
        this.enableSaveButton(index, comments);
      });
  }

  enableSaveButton(index: number, comments: string | undefined): void {
    const enable = comments != this.originalCasingLiners[index].comment;
    this.isDisabled[index] = !enable;
    this.reportPendingChanges();
  }

  menuOpened(trigger: any, index: number): void {
    this.indexMenuOpen = index;
  }

  menuClosed(index: number): void {
    this.indexMenuOpen = -1;
  }

  getCSSClassButton(groupValues: GroupCasingLiner[]) {
    let cssClasses;
    if (groupValues.length <= 1) {
      cssClasses = {
        'enable-button': true,
      };
    } else {
      cssClasses = {
        'enable-button': false,
      };
    }
    return cssClasses;
  }

  reportPendingChanges(): void {
    let thereAreChanges = false;
    for (let index = 0; index < this.casingsLiners.length; index++) {
      thereAreChanges =
        thereAreChanges ||
        this.casingsLiners[index].comment !=
          this.originalCasingLiners[index].comment;
    }
    this.emitPendingChanges(thereAreChanges);
  }
}
